import React from 'react'
import Input from './common/Input'

const FormField = ({ label, type = 'text', ...props }) => (
  <Input
    label={label}
    type={type}
    {...props}
  />
)

const TextArea = ({ label, ...props }) => (
  <div className="flex flex-col">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <textarea
      className="w-full px-4 py-2.5 bg-white rounded-xl shadow-[0_2px_8px_rgb(0,0,0,0.08)] focus:shadow-[0_2px_8px_rgb(0,0,0,0.12)] focus:ring-0 focus:outline-none text-gray-900 min-h-[100px] text-sm"
      {...props}
    />
  </div>
)

const PhoneGroupForm = ({ onSubmit, onCancel, initialValues = {} }) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = Object.fromEntries(formData.entries())
    onSubmit(data)
  }

  return (
    <div className="min-h-screen sm:min-h-0 bg-white sm:rounded-xl p-4 sm:p-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6">{initialValues.id ? '编辑电话分组' : '新增电话分组'}</h2>
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          <div className="grid grid-cols-1 gap-4 sm:gap-6">
            <FormField
              name="owner_name"
              label="小组拥有人"
              placeholder="请输入小组拥有人"
              defaultValue={initialValues.owner_name}
              required
            />

            <FormField
              name="ratio"
              label="比例"
              type="number"
              placeholder="请输入比例 (如 100)"
              defaultValue={initialValues.ratio}
              required
            />

            <TextArea
              name="phone_numbers"
              label="小组内关联的电话号码"
              placeholder="请输入电话号码，多个号码可以用逗号或换行分隔"
              defaultValue={initialValues.phone_numbers}
              required
            />
          </div>

          <div className="flex justify-end gap-3 pt-6 border-t border-gray-100">
            <button
              type="button"
              onClick={onCancel}
              className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors duration-200"
            >
              取消
            </button>
            <button
              type="submit"
              className="px-6 py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors duration-200 shadow-sm shadow-blue-600/20"
            >
              保存
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PhoneGroupForm